import { RequestService } from "../../../../common/services/RequestService";
import { DOWNLOAD_DOCUMENT } from "./constants";

export const downloadDocumentRequest = async (orderId, key) => {
  const response = await RequestService.post(
    DOWNLOAD_DOCUMENT.replace("{order_id}", orderId),
    { types: Array.isArray(key) ? key : [key] },
    { responseType: "blob" }
  );
  return response;
};
